import firebase from 'firebase/compat/app';
import { persistor } from '../App';
import * as actionConstants from '../actionConstants';
import { clearLocationState } from './locationActions';

export const authenticateWithEmailAddressAndPassword = (email, password) => {
  return dispatch => {
    console.log('Attempting login for:', email);
    dispatch({type: actionConstants.LOGGING_IN});
    firebase.auth()
      .signInWithEmailAndPassword(email.toLowerCase(), password)
      .then(user => {
        console.log('Firebase Auth successful for user:', user.uid);
        if (user) {
          dispatch(finishLogin());
        }
      })
      .catch(error => {
        console.log('Firebase Auth failed:', error);
        console.log('Error code:', error.code);
        console.log('Error message:', error.message);
        dispatch({type: actionConstants.LOGIN_FAIL, payload: error});
      });
  };
};

/**
 * Send password reset email
 *
 * @param email
 * @returns {Function}
 */
export const sendPasswordResetEmail = (email) => {
  return dispatch => {
    dispatch({type: actionConstants.SENDING_PASSWORD_RESET});
    firebase.auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        dispatch({
          type: actionConstants.SENT_PASSWORD_RESET
        });
      })
      .catch(error => {
        dispatch({type: actionConstants.SENT_PASSWORD_RESET, payload: error});
      });
  };
};

export const finishLogin = () => {
  return async (dispatch, getState) => {
    let currentUser = await firebase.auth().currentUser;
    console.log('finishLogin - Current user from Firebase Auth:', currentUser);
    console.log('finishLogin - User UID:', currentUser?.uid);
    
    dispatch({type: actionConstants.LOADING_USER});
    
    try {
      let userDoc = await firebase
        .firestore()
        .collection('users')
        .doc(currentUser.uid)
        .get();
      
      console.log('finishLogin - Document exists:', userDoc.exists);
      console.log('finishLogin - User data:', userDoc.data());
      console.log('finishLogin - User active status:', userDoc.data()?.active);
      console.log('finishLogin - User type:', userDoc.data()?.type);
      
      if (userDoc.exists && userDoc.data().active) {
        console.log('finishLogin - User is active, dispatching LOADED_USER');
        dispatch({ type: actionConstants.LOADED_USER, payload: {id: userDoc.id, ...userDoc.data()}});
      } else {
        console.log('finishLogin - User not active or missing active field');
        console.log('finishLogin - Document exists:', userDoc.exists);
        console.log('finishLogin - Active field:', userDoc.data()?.active);
        dispatch({type: actionConstants.LOGIN_FAIL});
      }
    } catch (error) {
      console.log('finishLogin - Error loading user data:', error);
      console.log('finishLogin - Error code:', error.code);
      console.log('finishLogin - Error message:', error.message);
      dispatch({type: actionConstants.LOGIN_FAIL})
    }
  }
};

export const logout = () => {
  return async (dispatch, getState) => {
    await firebase.auth().signOut()
    persistor.purge()
  }
};
